<template>
<!-- @touchmove.prevent 阻止移动端屏幕滚动 -->
  <div id="app" class="g-app-wrapper" @touchmove.prevent>
    <header-nav v-if="headNavFlag" :showMaskFlag="showMaskFlag" ref="headerNav" @maskFlagChange="maskFlagChange"></header-nav>
    <keep-alive :include="keepAliveList">
      <router-view v-if="isRouterAlive"></router-view>
    </keep-alive>
    <transition name="fade">
      <div class="mask" v-show="showMaskFlag" @click="hideMask"></div>
    </transition>
  </div>
</template>

<script>
  import * as util from 'assets/js/util';
  import {share, ERR_OK} from 'api/config';
  import {getWxJsApiConfig} from 'api/wx';
  import {mapMutations, mapGetters} from 'vuex';
  import fixedBtn from 'components/common/fixed/fixed';
  import Scroll from 'base/scroll/scroll';
  import header from 'components/common/header/header';
  import nav from 'components/common/nav/nav';
  import wx from 'weixin-js-sdk';
  import headerNav from 'components/common/headerNav/index';
  export default {
    name: 'App',
    provide() {
      return {
        reload: this.reload
      };
    },
    data() {
      return {
        keepAliveList: /^KA_root/,
        isRouterAlive: true,
        progressText: '',
        progressPercentage: 0,
        shareInfo: share,
        showMaskFlag: false,
        headNavFlag: true // 导航状态 
      };
    },
    watch: {
      $route: {
        handler(val, old) {
          this.routerF(val.path)
        }
      },
      deep: true,
      immediate: true
    },
    created() {
      var browser = util.common.getbrowserType();
      this.isWechat = /^1.*/.test(browser);
      const roter = this.$route.path
      this.routerF(roter)
    },
    mounted() {
    },
    computed: {
    },
    methods: {
      // 路由过滤 dev
      routerF(path){
        // if (path == '/pcbCraftSecondary'){
        //   if (window.history.length <= 1){
        //     this.headNavFlag = true  
        //   } else {
        //     this.headNavFlag = false  
        //   }
        // }
        if (path == '/processDeliver' || path == '/pcbAdeliver'){
          this.headNavFlag = false
        } else {
          this.headNavFlag = true
        }
      },
      reload() {
        this.isRouterAlive = !this.isRouterAlive;
      },
      maskFlagChange(val){
        this.showMaskFlag = val;
      },
      hideMask() {
        this.showMaskFlag = false;
      },
      initWeixinShare() {
        this._getWxJsApiConfig().then((res) => {
          if (res.code) {
            if (res.code != ERR_OK) {
              return Promise.reject(res);
            }
            this.wxInit(res);
          }
        }).catch(e => {
          this.$emit('error', e);
        }).finally(() => {
          this.$emit('getConfigEnd');
        });
      },
      wxInit(data) {
        let shareInfo = this.shareInfo;
        wx.config({
//          debug: true, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: data.result.appId, // 必填，公众号的唯一标识
          timestamp: data.result.timestamp, // 必填，生成签名的时间戳
          nonceStr: data.result.nonceStr, // 必填，生成签名的随机串
          signature: data.result.signature, // 必填，签名，见附录1
          jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage', 'onMenuShareQQ', 'onMenuShareWeibo', 'onMenuShareQZone'] // 必填，需要使用的JS接口列表
        });
        wx.ready(() => {
          // alert('ready');
          //  alert(imgUrl);
          wx.onMenuShareTimeline({//  分享到朋友圈
            title: shareInfo.title, // 分享标题
            desc: shareInfo.desc, // 分享描述
            link: shareInfo.url, // 分享链接
            imgUrl: shareInfo.cover // 分享图标
          });
          wx.onMenuShareAppMessage({//  分享给朋友
            title: shareInfo.title, // 分享标题
            desc: shareInfo.desc, // 分享描述
            link: shareInfo.url, // 分享链接
            imgUrl: shareInfo.cover, // 分享图标
            type: 'link', // 分享类型,music、video或link，不填默认为link
            dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
            trigger: function (res) {
              //  alert("分享给朋友");
            },
            success: function () {
              // 用户确认分享后执行的回调函数
              //  alert("分享给朋友OK");
            },
            cancel: function () {
              // 用户取消分享后执行的回调函数
              // alert("分享给朋友cancel");
            }
          });
          wx.onMenuShareQQ({//  分享到QQ
            title: shareInfo.title, // 分享标题
            desc: shareInfo.desc, // 分享描述
            link: shareInfo.url, // 分享链接
            imgUrl: shareInfo.cover // 分享图标
          });
          wx.onMenuShareWeibo({// 分享到腾讯微博
            title: shareInfo.title, // 分享标题
            desc: shareInfo.desc, // 分享描述
            link: shareInfo.url, // 分享链接
            imgUrl: shareInfo.cover // 分享图标
          });
          wx.onMenuShareQZone({// 分享到QQ空间
            title: shareInfo.title, // 分享标题
            desc: shareInfo.desc, // 分享描述
            link: shareInfo.url, // 分享链接
            imgUrl: shareInfo.cover // 分享图标
          });
          // config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中。

        });
        wx.error((res) => {
          // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
          console.log(res);
          this.topTipAutoHide = true;
          this.toptipTxt = res.errMsg;
          this.$refs.toptip.show();
        });
      },
      _getWxJsApiConfig() {
//        alert(window.location.href);
        this.$emit('getConfigStart');
        let params = {
          url: window.location.href
        };
        return getWxJsApiConfig(params, {
          concurrent: true
        });
      }
    },
    components: {
      Scroll,
      fixedBtn,
      headerNav
    }
  };
</script>

<style scoped lang="scss" rel="stylesheet/scss">
  @import "~assets/scss/compile";
  @import "baseFrame";
</style>



// WEBPACK FOOTER //
// src/components/baseFrame/baseFrame.vue